module.exports = __webpack_public_path__ + "sk-rv-life-mockup.g1fzGWL3.png";